export const byId = (state) => (id) => state.list[id];
export const inArray = (state) => Object.values(state.list);
